import React from 'react'

type ClipboardIconProps = {
  width?: number | string
  height?: number | string
  className?: string
  color?: string
}

export const ClipboardIcon = ({ width = 20, height = 20, className, color = 'currentColor' }: ClipboardIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.3333 3.33333H15C15.442 3.33333 15.8659 3.50893 16.1785 3.82149C16.4911 4.13405 16.6667 4.55797 16.6667 5V16.6667C16.6667 17.1087 16.4911 17.5326 16.1785 17.8452C15.8659 18.1577 15.442 18.3333 15 18.3333H5C4.55797 18.3333 4.13405 18.1577 3.82149 17.8452C3.50893 17.5326 3.33333 17.1087 3.33333 16.6667V5C3.33333 4.55797 3.50893 4.13405 3.82149 3.82149C4.13405 3.50893 4.55797 3.33333 5 3.33333H6.66667M7.5 1.66667H12.5C12.9602 1.66667 13.3333 2.03976 13.3333 2.5V4.16667C13.3333 4.6269 12.9602 5 12.5 5H7.5C7.03976 5 6.66667 4.6269 6.66667 4.16667V2.5C6.66667 2.03976 7.03976 1.66667 7.5 1.66667Z"
      stroke={color}
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
